export const siteMeta = {
  name: '91精选',
  tagline: '热门视频与资源合集导航',
  intro:
    '91精选把分散在各处的视频与资源整理成清晰的合集与榜单，按热门、分类、推荐等维度重新编排，帮助你在一屏之内看清当前高人气内容，把筛选的时间省下来。',
};

export const categories = [
  { id: 'movie', name: '影视解说', icon: 'ri-movie-2-line', count: 128 },
  { id: 'game', name: '游戏实况', icon: 'ri-gamepad-line', count: 96 },
  { id: 'knowledge', name: '知识科普', icon: 'ri-lightbulb-line', count: 84 },
  { id: 'music', name: '音乐现场', icon: 'ri-music-2-line', count: 73 },
  { id: 'food', name: '美食探店', icon: 'ri-restaurant-2-line', count: 110 },
  { id: 'travel', name: '旅行记录', icon: 'ri-flight-takeoff-line', count: 67 },
  { id: 'tech', name: '数码评测', icon: 'ri-smartphone-line', count: 59 },
  { id: 'anime', name: '动漫剪辑', icon: 'ri-emotion-happy-line', count: 88 },
  { id: 'doc', name: '纪录片', icon: 'ri-earth-line', count: 45 },
  { id: 'fitness', name: '运动健身', icon: 'ri-run-line', count: 76 },
  { id: 'diy', name: '手工DIY', icon: 'ri-hammer-line', count: 39 },
  { id: 'pet', name: '宠物日常', icon: 'ri-heart-3-line', count: 52 },
];

export const collections = [
  {
    id: 'c1',
    title: '年度高分科幻片单 · 12 部一次看全',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%B9%B4%E5%BA%A6%E9%AB%98%E5%88%86%E7%A7%91%E5%B9%BB%E7%94%B5%E5%BD%B1%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%B7%B1%E9%82%83%E6%98%9F%E7%A9%BA%E4%B8%8E%E9%9C%93%E8%99%B9%E5%85%89%E6%99%95%2C%E5%86%B7%E8%B0%83%E7%A7%91%E6%8A%80%E6%B0%9B%E5%9B%B4%2C%E9%AB%98%E7%BA%A7%E7%AE%80%E7%BA%A6%E7%94%B5%E5%BD%B1%E6%84%9F%E5%B0%81%E9%9D%A2%E6%9E%84%E5%9B%BE%2C%E9%80%82%E5%90%88%E4%BD%9C%E4%B8%BA%E8%A7%86%E9%A2%91%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-scifi-01&orientation=landscape',
    categoryId: 'movie',
    categoryName: '影视解说',
    tags: ['科幻', '片单', '高分'],
    rating: '4.9',
    views: '128万',
    duration: '合集 6 小时',
    author: '星际放映厅',
    desc: '从硬核物理到软科幻温情，按口碑与讨论度梳理十二部代表作，附每部的看点提示与观看顺序建议。',
  },
  {
    id: 'c2',
    title: '零基础居家健身入门合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%B1%85%E5%AE%B6%E5%81%A5%E8%BA%AB%E8%AE%AD%E7%BB%83%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%98%8E%E4%BA%AE%E5%AE%A2%E5%8E%85%E4%B8%8E%E7%91%9C%E4%BC%BD%E5%9E%AB%2C%E6%9F%94%E5%92%8C%E8%87%AA%E7%84%B6%E5%85%89%2C%E6%B4%BB%E5%8A%9B%E6%A9%99%E8%89%B2%E7%82%B9%E7%BC%80%2C%E7%AE%80%E6%B4%81%E5%B9%B2%E5%87%80%E7%9A%84%E5%B0%81%E9%9D%A2%E9%A3%8E%E6%A0%BC%2C%E9%80%82%E5%90%88%E5%81%A5%E8%BA%AB%E6%95%99%E7%A8%8B%E5%90%88%E9%9B%86&width=800&height=450&seq=collection-fitness-02&orientation=landscape',
    categoryId: 'fitness',
    categoryName: '运动健身',
    tags: ['健身', '入门', '无器械'],
    rating: '4.8',
    views: '96万',
    duration: '合集 4 小时',
    author: '每日十分钟',
    desc: '全程无器械，从热身、核心到拉伸按周编排，每一节都标注强度与适合人群，跟着练就能上手。',
  },
  {
    id: 'c3',
    title: '深夜食堂 · 城市美食探店合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E6%B7%B1%E5%A4%9C%E5%9F%8E%E5%B8%82%E7%BE%8E%E9%A3%9F%E8%A1%97%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%9A%96%E9%BB%84%E7%81%AF%E5%85%89%E4%B8%8E%E8%B7%AF%E8%BE%B9%E5%B0%8F%E6%91%8A%2C%E7%83%AD%E6%B0%94%E8%85%BE%E8%85%BE%E7%9A%84%E9%A3%9F%E7%89%A9%E7%89%B9%E5%86%99%E6%B0%9B%E5%9B%B4%2C%E7%83%9F%E7%81%AB%E6%B0%94%E6%B5%93%E9%83%81%E7%9A%84%E5%A4%9C%E5%B8%82%E5%9C%BA%E6%99%AF%2C%E9%80%82%E5%90%88%E7%BE%8E%E9%A3%9F%E6%8E%A2%E5%BA%97%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-food-03&orientation=landscape',
    categoryId: 'food',
    categoryName: '美食探店',
    tags: ['探店', '夜宵', '城市'],
    rating: '4.7',
    views: '110万',
    duration: '合集 3 小时',
    author: '巷口食单',
    desc: '按街区串联几十家深夜小店，覆盖烧烤、粉面与糖水，每家都附人均、营业时段与必点清单。',
  },
  {
    id: 'c4',
    title: '4K 超清自然纪录片精选',
    cover:
      'https://readdy.ai/api/search-image?query=%E8%87%AA%E7%84%B6%E7%BA%AA%E5%BD%95%E7%89%87%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E5%A3%AE%E9%98%94%E5%B1%B1%E8%84%89%E4%B8%8E%E6%99%A8%E9%9B%BE%E6%A3%AE%E6%9E%97%2C%E8%BF%81%E5%BE%99%E7%9A%84%E9%B8%9F%E7%BE%A4%2C%E9%9D%92%E7%BB%BF%E8%89%B2%E8%87%AA%E7%84%B6%E8%B0%83%2C%E9%9C%87%E6%92%BC%E9%AB%98%E6%B8%85%E8%88%AA%E6%8B%8D%E8%B4%A8%E6%84%9F%2C%E9%80%82%E5%90%88%E7%BA%AA%E5%BD%95%E7%89%87%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-nature-04&orientation=landscape',
    categoryId: 'doc',
    categoryName: '纪录片',
    tags: ['纪录片', '自然', '4K'],
    rating: '4.9',
    views: '87万',
    duration: '合集 8 小时',
    author: '旷野镜头',
    desc: '横跨极地、雨林与深海三大篇章，逐集介绍拍摄背景与物种知识，适合作为自然科普的入门片单。',
  },
  {
    id: 'c5',
    title: '独立音乐人现场 Live 合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E7%8B%AC%E7%AB%8B%E9%9F%B3%E4%B9%90%E7%8E%B0%E5%9C%BA%E6%BC%94%E5%87%BA%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E8%88%9E%E5%8F%B0%E7%81%AF%E6%9D%9F%E4%B8%8E%E8%A7%82%E4%BC%97%E5%89%AA%E5%BD%B1%2C%E6%9A%96%E6%A9%99%E4%B8%8E%E9%9D%92%E7%BB%BF%E8%89%B2%E7%81%AF%E5%85%89%E4%BA%A4%E7%BB%87%2C%E9%9F%B3%E4%B9%90%E8%8A%82%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E7%8E%B0%E5%9C%BALive%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-music-05&orientation=landscape',
    categoryId: 'music',
    categoryName: '音乐现场',
    tags: ['现场', 'Live', '摇滚'],
    rating: '4.6',
    views: '64万',
    duration: '合集 5 小时',
    author: '台下第三排',
    desc: '收录十余组乐队的小型现场实录，按民谣、摇滚、电子分组，每段都标注场地与演出年份。',
  },
  {
    id: 'c6',
    title: '七日城市漫游旅行 vlog 合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%9F%8E%E5%B8%82%E6%97%85%E8%A1%8Cvlog%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%B8%85%E6%99%A8%E7%9F%B3%E6%9D%BF%E8%A1%97%E9%81%93%E4%B8%8E%E8%80%81%E5%BB%BA%E7%AD%91%2C%E6%9F%94%E5%92%8C%E6%99%A8%E5%85%89%E4%B8%8E%E8%A1%8C%E4%BA%BA%E5%89%AA%E5%BD%B1%2C%E6%A9%99%E9%BB%84%E4%B8%8E%E9%9D%92%E7%BB%BF%E6%92%9E%E8%89%B2%2C%E9%80%82%E5%90%88%E6%97%85%E8%A1%8C%E8%AE%B0%E5%BD%95%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-travel-06&orientation=landscape',
    categoryId: 'travel',
    categoryName: '旅行记录',
    tags: ['旅行', 'vlog', '城市'],
    rating: '4.7',
    views: '78万',
    duration: '合集 3.5 小时',
    author: '慢慢走地图',
    desc: '用七天路线还原一座城的日常，包含交通、住宿与路线图，边走边讲本地人才知道的小众视角。',
  },
  {
    id: 'c7',
    title: '旗舰手机深度评测合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E6%95%B0%E7%A0%81%E6%97%97%E8%88%B0%E6%89%8B%E6%9C%BA%E8%AF%84%E6%B5%8B%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E7%AE%80%E6%B4%81%E6%A1%8C%E9%9D%A2%E4%B8%8E%E5%A4%9A%E5%8F%B0%E6%89%8B%E6%9C%BA%E6%8E%92%E5%88%97%2C%E5%86%B7%E7%81%B0%E7%A7%91%E6%8A%80%E8%83%8C%E6%99%AF%2C%E9%87%91%E5%B1%9E%E8%B4%A8%E6%84%9F%E4%B8%8E%E5%B1%8F%E5%B9%95%E5%8F%8D%E5%85%89%2C%E9%80%82%E5%90%88%E6%95%B0%E7%A0%81%E8%AF%84%E6%B5%8B%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-tech-07&orientation=landscape',
    categoryId: 'tech',
    categoryName: '数码评测',
    tags: ['数码', '评测', '手机'],
    rating: '4.5',
    views: '59万',
    duration: '合集 2.5 小时',
    author: '参数之外',
    desc: '不看跑分看体验，围绕影像、续航、散热与系统四大维度做横向对比，附各价位的购买建议。',
  },
  {
    id: 'c8',
    title: '治愈系动漫经典片段合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E6%B2%BB%E6%84%88%E7%B3%BB%E5%8A%A8%E6%BC%AB%E9%A3%8E%E6%A0%BC%E6%8F%92%E7%94%BB%E8%A7%86%E8%A7%89%2C%E5%8D%88%E5%90%8E%E6%95%99%E5%AE%A4%E4%B8%8E%E9%A3%98%E8%90%BD%E6%A8%B1%E8%8A%B1%2C%E6%9F%94%E5%92%8C%E7%B2%89%E6%A9%99%E8%89%B2%E5%A4%A9%E7%A9%BA%2C%E6%B8%85%E6%96%B0%E6%B8%A9%E6%9A%96%E7%9A%84%E6%97%A5%E7%B3%BB%E7%94%BB%E9%A3%8E%2C%E9%80%82%E5%90%88%E5%8A%A8%E6%BC%AB%E5%89%AA%E8%BE%91%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-anime-08&orientation=landscape',
    categoryId: 'anime',
    categoryName: '动漫剪辑',
    tags: ['动漫', '治愈', '剪辑'],
    rating: '4.8',
    views: '88万',
    duration: '合集 4 小时',
    author: '夏日放映室',
    desc: '挑选一批情绪浓度高的名场面，按燃向、泪点、日常分类，配有出场背景与作品年份说明。',
  },
  {
    id: 'c9',
    title: '复古胶片摄影入门合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%A4%8D%E5%8F%A4%E8%83%B6%E7%89%87%E6%91%84%E5%BD%B1%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E8%80%81%E5%BC%8F%E7%9B%B8%E6%9C%BA%E4%B8%8E%E6%95%A3%E8%90%BD%E8%83%B6%E7%89%87%2C%E6%9A%96%E6%A3%95%E8%89%B2%E8%B0%83%E4%B8%8E%E9%A2%97%E7%B2%92%E8%B4%A8%E6%84%9F%2C%E6%9F%94%E5%92%8C%E7%AA%97%E5%85%89%2C%E9%80%82%E5%90%88%E6%91%84%E5%BD%B1%E6%95%99%E7%A8%8B%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-photo-09&orientation=landscape',
    categoryId: 'knowledge',
    categoryName: '知识科普',
    tags: ['摄影', '胶片', '教程'],
    rating: '4.6',
    views: '43万',
    duration: '合集 2 小时',
    author: '光圈三层',
    desc: '从测光、构图到显影流程完整走一遍，讲解不同胶卷的色彩倾向，附新手常踩的坑与避雷清单。',
  },
  {
    id: 'c10',
    title: '手冲咖啡从入门到精通',
    cover:
      'https://readdy.ai/api/search-image?query=%E6%89%8B%E5%86%B2%E5%92%96%E5%95%A1%E6%95%99%E7%A8%8B%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%9C%A8%E8%B4%A8%E5%90%A7%E5%8F%B0%E4%B8%8E%E6%89%8B%E5%86%B2%E5%A3%B6%2C%E7%83%AD%E6%B0%B4%E6%B3%A8%E5%85%A5%E6%BB%A4%E6%9D%AF%E7%9A%84%E8%92%B8%E6%B1%BD%2C%E6%9A%96%E6%A3%95%E4%B8%8E%E9%9D%92%E7%BB%BF%E7%82%B9%E7%BC%80%2C%E5%AE%89%E9%9D%99%E6%B2%BB%E6%84%88%E7%9A%84%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E5%92%96%E5%95%A1%E6%95%99%E7%A8%8B%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-coffee-10&orientation=landscape',
    categoryId: 'food',
    categoryName: '美食探店',
    tags: ['咖啡', '教程', '生活'],
    rating: '4.7',
    views: '51万',
    duration: '合集 1.5 小时',
    author: '慢焙手记',
    desc: '拆解水温、粉水比与注水节奏三个变量，用对照实验说明风味差异，帮你找到属于自己的那杯。',
  },
  {
    id: 'c11',
    title: '猫咪日常爆笑合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%AF%E7%88%B1%E7%8C%AB%E5%92%AA%E6%97%A5%E5%B8%B8%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E9%98%B3%E5%85%89%E5%AE%A2%E5%8E%85%E9%87%8C%E7%9A%84%E6%A9%98%E7%8C%AB%E4%B8%8E%E6%AF%9B%E7%BA%BF%E7%90%83%2C%E6%9F%94%E5%92%8C%E6%9A%96%E5%85%89%2C%E5%B9%B2%E5%87%80%E6%B8%A9%E9%A6%A8%E7%9A%84%E5%B1%85%E5%AE%B6%E8%83%8C%E6%99%AF%2C%E8%BD%BB%E6%9D%BE%E6%B2%BB%E6%84%88%E7%9A%84%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E5%AE%A0%E7%89%A9%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-cat-11&orientation=landscape',
    categoryId: 'pet',
    categoryName: '宠物日常',
    tags: ['宠物', '猫咪', '搞笑'],
    rating: '4.9',
    views: '132万',
    duration: '合集 2 小时',
    author: '有猫青年',
    desc: '把猫咪拆家、打翻水杯与半夜蹦迪的瞬间剪成合集，每一段都标注了当时猫咪的迷惑行为。',
  },
  {
    id: 'c12',
    title: '极简桌面改造与好物合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E6%9E%81%E7%AE%80%E6%A1%8C%E9%9D%A2%E6%94%B9%E9%80%A0%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%95%B4%E6%B4%81%E6%9C%A8%E8%B4%A8%E4%B9%A6%E6%A1%8C%E4%B8%8E%E6%98%BE%E7%A4%BA%E5%99%A8%2C%E6%9F%94%E5%92%8C%E8%87%AA%E7%84%B6%E5%85%89%E4%B8%8E%E7%BB%BF%E6%A4%8D%2C%E5%B9%B2%E5%87%80%E5%85%8B%E5%88%B6%E7%9A%84%E6%94%B6%E7%BA%B3%E7%BE%8E%E5%AD%A6%2C%E9%80%82%E5%90%88%E6%A1%8C%E9%9D%A2%E6%94%B9%E9%80%A0%E5%90%88%E9%9B%86%E5%B0%81%E9%9D%A2&width=800&height=450&seq=collection-desk-12&orientation=landscape',
    categoryId: 'tech',
    categoryName: '数码评测',
    tags: ['桌面', '好物', '改造'],
    rating: '4.6',
    views: '67万',
    duration: '合集 2.5 小时',
    author: '一平米工作室',
    desc: '在有限空间里重新排布线材、灯光与收纳，附改造前后对比与预算拆解，适合出租屋参考。',
  },
];

export const trending = [
  { rank: 1, title: '悬疑神作《迷雾档案》第一季全集解说', cover: 'https://readdy.ai/api/search-image?query=%E6%82%AC%E7%96%91%E7%94%B5%E5%BD%B1%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E9%9B%A8%E5%A4%9C%E8%A1%97%E7%81%AF%E4%B8%8E%E6%A8%A1%E7%B3%8A%E4%BA%BA%E5%BD%B1%2C%E6%B7%B1%E9%9D%92%E8%89%B2%E8%B0%83%E4%B8%8E%E9%9B%BE%E6%B0%94%2C%E7%94%B5%E5%BD%B1%E6%84%9F%E6%9E%84%E5%9B%BE%2C%E9%80%82%E5%90%88%E6%82%AC%E7%96%91%E8%A7%A3%E8%AF%B4%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-mystery-01&orientation=landscape', categoryName: '影视解说', heat: '98.6', trend: 'up' },
  { rank: 2, title: '城市骑行夜拍 · 4K 沉浸式路线记录', cover: 'https://readdy.ai/api/search-image?query=%E5%9F%8E%E5%B8%82%E5%A4%9C%E9%97%B4%E9%AA%91%E8%A1%8C%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E8%A1%97%E9%81%93%E9%9C%93%E8%99%B9%E4%B8%8E%E8%BD%A6%E6%B5%81%E5%85%89%E8%BD%A8%2C%E5%8A%A8%E6%80%81%E8%BF%90%E5%8A%A8%E6%A8%A1%E7%B3%8A%2C%E6%A9%99%E9%9D%92%E5%AF%B9%E6%AF%94%E8%89%B2%E8%B0%83%2C%E9%80%82%E5%90%88%E9%AA%91%E8%A1%8C%E8%AE%B0%E5%BD%95%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-riding-02&orientation=landscape', categoryName: '旅行记录', heat: '96.2', trend: 'up' },
  { rank: 3, title: '冠军赛全场高光集锦', cover: 'https://readdy.ai/api/search-image?query=%E4%BD%93%E8%82%B2%E8%B5%9B%E4%BA%8B%E9%AB%98%E5%85%89%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E5%9C%BA%E9%A6%86%E7%81%AF%E5%85%89%E4%B8%8E%E8%BF%90%E5%8A%A8%E5%91%98%E5%89%AA%E5%BD%B1%2C%E5%8A%A8%E6%84%9F%E7%9E%AC%E9%97%B4%E5%AE%9A%E6%A0%BC%2C%E7%83%AD%E8%A1%80%E6%A9%99%E7%BA%A2%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E8%B5%9B%E4%BA%8B%E9%9B%86%E9%94%A6%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-sports-03&orientation=landscape', categoryName: '运动健身', heat: '94.8', trend: 'flat' },
  { rank: 4, title: '三分钟看懂量子计算入门', cover: 'https://readdy.ai/api/search-image?query=%E9%87%8F%E5%AD%90%E8%AE%A1%E7%AE%97%E7%A7%91%E6%99%AE%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%8A%BD%E8%B1%A1%E5%87%A0%E4%BD%95%E7%B2%92%E5%AD%90%E4%B8%8E%E5%85%89%E7%82%B9%2C%E6%B7%B1%E9%9D%92%E4%B8%8E%E6%A9%99%E8%89%B2%E7%A7%91%E6%8A%80%E6%84%9F%2C%E7%AE%80%E6%B4%81%E7%A4%BA%E6%84%8F%E9%A3%8E%E6%A0%BC%2C%E9%80%82%E5%90%88%E7%A7%91%E6%99%AE%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-quantum-04&orientation=landscape', categoryName: '知识科普', heat: '92.4', trend: 'up' },
  { rank: 5, title: '街边小吃隐藏菜单大揭秘', cover: 'https://readdy.ai/api/search-image?query=%E8%A1%97%E5%A4%B4%E5%B0%8F%E5%90%83%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E7%83%AD%E6%B0%94%E8%85%BE%E8%85%BE%E7%9A%84%E8%B7%AF%E8%BE%B9%E6%91%8A%2C%E6%9A%96%E9%BB%84%E7%81%AF%E5%85%89%E4%B8%8E%E7%83%9F%E7%81%AB%E6%B0%94%2C%E9%A3%9F%E7%89%A9%E7%89%B9%E5%86%99%E8%B4%A8%E6%84%9F%2C%E9%80%82%E5%90%88%E7%BE%8E%E9%A3%9F%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-snack-05&orientation=landscape', categoryName: '美食探店', heat: '90.7', trend: 'down' },
  { rank: 6, title: '百元预算桌面焕新改造', cover: 'https://readdy.ai/api/search-image?query=%E6%A1%8C%E9%9D%A2%E6%94%B6%E7%BA%B3%E6%94%B9%E9%80%A0%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%95%B4%E9%BD%90%E7%BA%BF%E6%9D%90%E4%B8%8E%E6%94%B6%E7%BA%B3%E7%9B%92%2C%E6%9F%94%E5%92%8C%E5%AE%A4%E5%86%85%E5%85%89%2C%E5%B9%B2%E5%87%80%E5%85%8B%E5%88%B6%E7%9A%84%E6%9E%81%E7%AE%80%E9%A3%8E%E6%A0%BC%2C%E9%80%82%E5%90%88%E6%94%B9%E9%80%A0%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-desk-06&orientation=landscape', categoryName: '数码评测', heat: '88.9', trend: 'up' },
  { rank: 7, title: '深夜电台 · 告白歌曲串烧', cover: 'https://readdy.ai/api/search-image?query=%E6%B7%B1%E5%A4%9C%E7%94%B5%E5%8F%B0%E9%9F%B3%E4%B9%90%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%9A%96%E9%BB%84%E5%8F%B0%E7%81%AF%E4%B8%8E%E9%BA%A6%E5%85%8B%E9%A3%8E%2C%E5%AE%89%E9%9D%99%E6%88%BF%E9%97%B4%E6%B0%9B%E5%9B%B4%2C%E6%B8%A9%E6%9F%94%E6%9A%96%E8%B0%83%E5%85%89%E5%BD%B1%2C%E9%80%82%E5%90%88%E9%9F%B3%E4%B9%90%E4%B8%B2%E7%83%A7%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-radio-07&orientation=landscape', categoryName: '音乐现场', heat: '86.3', trend: 'flat' },
  { rank: 8, title: '冰岛环岛自驾航拍纪实', cover: 'https://readdy.ai/api/search-image?query=%E5%86%B0%E5%B2%9B%E7%8E%AF%E5%B2%9B%E8%87%AA%E9%A9%BE%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E8%8D%92%E5%8E%9F%E5%85%AC%E8%B7%AF%E4%B8%8E%E8%BF%9C%E5%A4%84%E9%9B%AA%E5%B1%B1%2C%E7%81%B0%E8%93%9D%E5%86%B7%E8%B0%83%E5%A4%A9%E7%A9%BA%2C%E5%A3%AE%E9%98%94%E8%88%AA%E6%8B%8D%E8%A7%86%E8%A7%92%2C%E9%80%82%E5%90%88%E6%97%85%E8%A1%8C%E7%BA%AA%E5%AE%9E%E5%B0%81%E9%9D%A2&width=480&height=300&seq=trend-iceland-08&orientation=landscape', categoryName: '旅行记录', heat: '84.1', trend: 'down' },
];

export const latest = [
  { title: '新番动画本周更新速览', cover: 'https://readdy.ai/api/search-image?query=%E5%8A%A8%E6%BC%AB%E6%96%B0%E7%95%AA%E9%80%9F%E8%A7%88%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E8%89%B2%E5%BD%A9%E6%98%8E%E5%BF%AB%E7%9A%84%E5%8A%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%E6%8F%92%E7%94%BB%2C%E6%98%9F%E7%A9%BA%E4%B8%8E%E8%A7%92%E8%89%B2%E5%89%AA%E5%BD%B1%2C%E6%B8%85%E6%96%B0%E6%97%A5%E7%B3%BB%E9%85%8D%E8%89%B2%2C%E9%80%82%E5%90%88%E5%8A%A8%E6%BC%AB%E8%B5%84%E8%AE%AF%E5%B0%81%E9%9D%A2&width=480&height=288&seq=latest-anime-01&orientation=landscape', categoryName: '动漫剪辑', duration: '12:40', time: '2 小时前' },
  { title: '家用投影仪横评更新版', cover: 'https://readdy.ai/api/search-image?query=%E5%AE%B6%E7%94%A8%E6%8A%95%E5%BD%B1%E4%BB%AA%E8%AF%84%E6%B5%8B%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%9A%97%E5%AE%A4%E4%B8%8E%E6%8A%95%E5%BD%B1%E5%85%89%E5%B9%95%2C%E5%86%B7%E7%81%B0%E7%A7%91%E6%8A%80%E8%83%8C%E6%99%AF%2C%E6%B8%85%E6%99%B0%E7%9A%84%E4%BA%A7%E5%93%81%E5%B1%95%E7%A4%BA%E8%B4%A8%E6%84%9F%2C%E9%80%82%E5%90%88%E6%95%B0%E7%A0%81%E8%AF%84%E6%B5%8B%E5%B0%81%E9%9D%A2&width=480&height=288&seq=latest-projector-02&orientation=landscape', categoryName: '数码评测', duration: '18:05', time: '5 小时前' },
  { title: '秋季限定美食探店', cover: 'https://readdy.ai/api/search-image?query=%E7%A7%8B%E5%AD%A3%E7%BE%8E%E9%A3%9F%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%9A%96%E8%89%B2%E9%A4%90%E6%A1%8C%E4%B8%8E%E5%BA%94%E5%AD%A3%E9%A3%9F%E7%89%A9%2C%E6%9F%94%E5%92%8C%E6%9A%96%E5%85%89%E4%B8%8E%E8%92%B8%E6%B1%BD%2C%E6%B8%A9%E9%A6%A8%E9%A4%90%E6%A1%8C%E9%9D%A2%2C%E9%80%82%E5%90%88%E7%BE%8E%E9%A3%9F%E6%8E%A2%E5%BA%97%E5%B0%81%E9%9D%A2&width=480&height=288&seq=latest-autumn-03&orientation=landscape', categoryName: '美食探店', duration: '09:22', time: '8 小时前' },
  { title: '城市天际线延时摄影', cover: 'https://readdy.ai/api/search-image?query=%E5%9F%8E%E5%B8%82%E5%A4%A9%E9%99%85%E7%BA%BF%E5%BB%B6%E6%97%B6%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E9%BB%84%E6%98%8F%E5%88%B0%E5%A4%9C%E6%99%9A%E7%9A%84%E9%AB%98%E6%A5%BC%E7%BE%A4%2C%E6%A9%99%E7%B4%AB%E6%B8%90%E5%8F%98%E5%A4%A9%E7%A9%BA%2C%E5%A3%AE%E9%98%94%E5%9F%8E%E5%B8%82%E8%BF%9C%E6%99%AF%2C%E9%80%82%E5%90%88%E5%BB%B6%E6%97%B6%E6%91%84%E5%BD%B1%E5%B0%81%E9%9D%A2&width=480&height=288&seq=latest-city-04&orientation=landscape', categoryName: '旅行记录', duration: '06:50', time: '今天' },
  { title: '居家拉伸训练完整版', cover: 'https://readdy.ai/api/search-image?query=%E5%B1%85%E5%AE%B6%E6%8B%89%E4%BC%B8%E8%AE%AD%E7%BB%83%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%98%8E%E4%BA%AE%E5%B1%85%E5%AE%A4%E4%B8%8E%E7%91%9C%E4%BC%BD%E5%9E%AB%2C%E6%9F%94%E5%92%8C%E8%87%AA%E7%84%B6%E5%85%89%2C%E5%B9%B2%E5%87%80%E8%88%92%E9%80%82%E7%9A%84%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E5%81%A5%E8%BA%AB%E6%95%99%E7%A8%8B%E5%B0%81%E9%9D%A2&width=480&height=288&seq=latest-stretch-05&orientation=landscape', categoryName: '运动健身', duration: '24:30', time: '今天' },
  { title: '手办开箱与展示分享', cover: 'https://readdy.ai/api/search-image?query=%E6%89%8B%E5%8A%9E%E5%BC%80%E7%AE%B1%E5%B1%95%E7%A4%BA%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E6%A1%8C%E9%9D%A2%E4%B8%8A%E7%9A%84%E7%B2%BE%E8%87%B4%E6%A8%A1%E5%9E%8B%E4%B8%8E%E7%81%AF%E5%85%89%2C%E5%B9%B2%E5%87%80%E8%83%8C%E6%99%AF%E4%B8%8E%E6%9F%94%E5%92%8C%E6%89%93%E5%85%89%2C%E6%94%B6%E8%97%8F%E5%B1%95%E7%A4%BA%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E5%BC%80%E7%AE%B1%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2&width=480&height=288&seq=latest-figure-06&orientation=landscape', categoryName: '手工DIY', duration: '14:18', time: '昨天' },
];

export const features = [
  {
    id: 'f1',
    label: '编辑精选',
    title: '一周内容精选：五部值得二刷的纪录片',
    cover:
      'https://readdy.ai/api/search-image?query=%E7%BA%AA%E5%BD%95%E7%89%87%E7%B2%BE%E9%80%89%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E5%A3%AE%E9%98%94%E8%87%AA%E7%84%B6%E6%99%AF%E8%A7%82%E4%B8%8E%E8%BF%9C%E8%A1%8C%E8%80%85%E8%83%8C%E5%BD%B1%2C%E9%9D%92%E7%BB%BF%E4%B8%8E%E6%9A%96%E6%A9%99%E5%AF%B9%E6%AF%94%2C%E7%94%B5%E5%BD%B1%E6%84%9F%E5%B9%BF%E8%A7%92%E6%9E%84%E5%9B%BE%2C%E9%80%82%E5%90%88%E4%B8%93%E9%A2%98%E6%8E%A8%E8%8D%90%E5%B0%81%E9%9D%A2&width=900&height=520&seq=feature-doc-01&orientation=landscape',
    summary: '从自然、人文到科技三条线索各挑一部，附上适合的观看时段与延伸阅读，帮你在周末搭出一份完整片单。',
  },
  {
    id: 'f2',
    label: '主题策划',
    title: '从入门到进阶：新手友好的知识科普合集',
    cover:
      'https://readdy.ai/api/search-image?query=%E7%9F%A5%E8%AF%86%E7%A7%91%E6%99%AE%E5%AD%A6%E4%B9%A0%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E4%B9%A6%E6%9C%AC%E7%AC%94%E8%AE%B0%E4%B8%8E%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%2C%E6%B8%A9%E6%9A%96%E5%8F%B0%E7%81%AF%E4%B8%8E%E6%A1%8C%E9%9D%A2%2C%E5%AE%89%E9%9D%99%E4%B8%93%E6%B3%A8%E7%9A%84%E6%B0%9B%E5%9B%B4%2C%E9%80%82%E5%90%88%E7%A7%91%E6%99%AE%E4%B8%93%E9%A2%98%E5%B0%81%E9%9D%A2&width=900&height=520&seq=feature-knowledge-02&orientation=landscape',
    summary: '把零散知识按难度重新排序，从概念到应用逐层推进，每篇都标注前置知识，避免一上来就被劝退。',
  },
  {
    id: 'f3',
    label: '热度追踪',
    title: '暑期档动漫新番观察与推荐清单',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8A%A8%E6%BC%AB%E6%96%B0%E7%95%AA%E8%A7%82%E5%AF%9F%E4%B8%BB%E9%A2%98%E8%A7%86%E8%A7%89%2C%E7%BC%A4%E7%BA%B7%E5%A4%9C%E7%A9%BA%E4%B8%8E%E5%9F%8E%E5%B8%82%E5%89%AA%E5%BD%B1%2C%E6%B8%85%E6%96%B0%E6%98%8E%E4%BA%AE%E7%9A%84%E6%97%A5%E7%B3%BB%E6%8F%92%E7%94%BB%E9%A3%8E%2C%E5%85%85%E6%BB%A1%E6%B4%BB%E5%8A%9B%E7%9A%84%E9%85%8D%E8%89%B2%2C%E9%80%82%E5%90%88%E5%8A%A8%E7%94%BB%E4%B8%93%E9%A2%98%E5%B0%81%E9%9D%A2&width=900&height=520&seq=feature-anime-03&orientation=landscape',
    summary: '整理当季讨论度最高的几部作品，从制作阵容到话题走向逐一说明，方便你判断哪部值得追。',
  },
];

export const stats = [
  { label: '收录合集', value: '3,200+', sub: '持续整理中' },
  { label: '覆盖分类', value: '12 个', sub: '主流题材齐全' },
  { label: '每日更新', value: '80+', sub: '热门内容同步' },
  { label: '累计浏览', value: '2,600万', sub: '来自浏览者的选择' },
];

export const guideSteps = [
  { icon: 'ri-apps-2-line', title: '先选分类', desc: '在分类导航里点选你感兴趣的题材，页面会自动筛选出对应合集。' },
  { icon: 'ri-fire-line', title: '再看热门榜', desc: '不确定看什么时，从热门榜入手，按热度排序快速锁定当前高人气内容。' },
  { icon: 'ri-filter-3-line', title: '用标签细筛', desc: '在精选合集区输入关键词或点击标签，进一步缩小范围到具体主题。' },
  { icon: 'ri-bookmark-3-line', title: '整理你的清单', desc: '把感兴趣的合集记下来，按自己的节奏分批浏览，不必一次看完。' },
];

export const faqs = [
  {
    q: '91精选主要提供哪些内容？',
    a: '本站是对网络公开视频与资源的整理与导航，覆盖影视解说、游戏实况、知识科普、音乐现场、美食探店、旅行记录、数码评测、动漫剪辑等十余个题材，以合集与榜单的形式呈现，帮助你快速了解当前有哪些值得浏览的内容。',
  },
  {
    q: '怎样更快找到感兴趣的视频合集？',
    a: '可以先在分类导航中选定题材，再到精选合集区用关键词或标签进一步筛选；如果你只是想跟风看热门，直接从热门榜按热度顺序浏览即可。',
  },
  {
    q: '内容大概多久更新一次？',
    a: '合集与榜单会按周做一次系统性梳理，最新更新区则会持续补充近期整理的条目，日常更新以补充新内容为主，避免频繁改动已有的分类结构。',
  },
  {
    q: '可以直接按标签筛选合集吗？',
    a: '可以。在精选合集区提供了分类筛选、标签切换与关键词搜索三种方式，它们都只作用于本页已展示的内容，筛选结果会实时更新，不会跳转到其他页面。',
  },
  {
    q: '合集里的视频能直接在这里播放吗？',
    a: '本站定位为内容整理与导航，侧重分类、说明与推荐理由；具体的播放与版权归属以内容来源平台为准，本站不对第三方资源作任何形式的存储或转载。',
  },
];

export const footerLinks = [
  { label: '热门榜', href: '#trending' },
  { label: '分类导航', href: '#categories' },
  { label: '精选合集', href: '#collections' },
  { label: '最新更新', href: '#latest' },
  { label: '专题推荐', href: '#features' },
  { label: '常见问题', href: '#faq' },
];